import { useSyncExternalStore } from 'react';
import { dateStore, DateStore } from '../store';

export const useDateStore = (): DateStore => {
  return useSyncExternalStore(dateStore.subscribe, dateStore.getSnapshot);
};
